module.exports = __webpack_public_path__ + "static/media/RWFKO1024465_sm1.565a3bbd.png";